module.exports = __webpack_public_path__ + "static/media/wwc.9442c303.jpeg";